import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import moment from 'moment';
import { clone, get } from 'lodash';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast, Carousel } from 'antd-mobile';
import WxImageViewer from 'react-wx-images-viewer';
import { TextDialog } from '../../../components/textDialog';
import { Loading } from '../../../components/loading';
import { ShareTip } from '../../../components/copyright/shareTip';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { readCookie, getQueryString } from '../../../utils/common';
import { MINIPROGRAM_APPID } from '../../../utils/weixin';
import { _track } from '../../../utils/track';
import { DetailShare } from '../../../components/copyright/detailShare';
import { ImageInfo } from '../../../components/copyright/imageInfo';
import { DownloadTip } from '../../../components/downloadTip';
import { getImgInfo, getDownloadQRCode, sendDownloadInfo } from './action';
import { PhotoProvider, PhotoConsumer, PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
// import { defaultProps, skinnyProps } from '../gallery/data';
import './index.scss';
const mapStateToProps = state => {
	return {
		siteSwitch: state.AdminReducers.siteSwitch
	};
};
function CopyrightIdetail(props) {
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { siteSwitch } = useMappedState(mapState);
	const [carouselIndex, setCarouselIndex] = useState(-1);
	// const [isOpen, setIsOpen] = useState(false);
	// const [openUrl, setOpenUrl] = useState('');
	const [pageData, setPageData] = useState({
		isShowInstruction: false,
		isShowQRcodeInstruction: false,
		QRContent: '',
		// isShowShareTip: false,
		isShowShare: false,
		sharedData: {},
		isShowDownload: false,
		isOpen: false,
		openUrl: ''
	});
	const [imgInfo, setImgInfo] = useState({
		id: '',
		contentId: '',
		type: 1,
		userId: 11610,
		userNickname: '4119昵称',
		key: '',
		thumbKey: '',
		picDescription: '',
		description: '',
		submitTime: 0,
		crDate: 0,
		lat: null,
		city: '',
		width: 600,
		height: 885,
		size: 32513,
		authorUserName: null,
		authorUserId: null,
		workTraceResps: []
	});
	let [isDownloadTip, setIsDownloadTip] = useState(false);
	let [isTooBig, setIsTooBig] = useState(false);
	let dispatch = useDispatch();
	let params = useParams();
	let mySwiper = null;
	if (!get(props, 'location.state.defaultProps', '')) {
		window.location.href = '/vpmobile/copyright/home';
	}
	let { defaultProps = [], index, pathname, top, topicName, topicId, sectionDescription } = get(props, 'location.state', {});
	const [photoIndex, setPhotoIndex] = useState(index);
	console.log('props', props);
	console.log('topicName', topicName);
	function onCloseView() {
		pageData.isOpen = false;
		setPageData({ ...pageData });
	}
	function onOpenView() {
		pageData.isOpen = true;
		setPageData({ ...pageData });
	}
	function onTouchStart(e) {
		if (e.touches.length > 1) {
			let _index = carouselIndex === -1 ? index : carouselIndex;
			setCarouselIndex(_index);
			pageData.isOpen = true;
			setPageData({ ...pageData });
		}
	}
	function showShare() {
		let _index = carouselIndex === -1 ? index : carouselIndex;
		let item = items[_index];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				setImgInfo(data);
				let shareData = {
					// fromAvatar: avatar,
					// fromName: copyright_nickname,
					fromAvatar: readCookie('copyright_avatar'),
					fromName: readCookie('copyright_nickname'),
					photographerAvatar: data.avatar,
					photographerName: data.userNickname,
					topicName: topicName,
					contentId: data.contentId,
					// sectionId: '',
					title: sectionDescription,
					list: [
						{
							key: item.originalUrl || item.url,
							description: item.description
						}
					]
				};
				pageData.sharedData = shareData;
				pageData.isShowShare = true;
				setPageData({ ...pageData });
//				document.querySelector(".copyright-idetail").addEventListener('touchstart',bindTouchStart, false);
			})
		);
	}
	function closeShare() {
		pageData.isShowShare = false;
		setPageData({ ...pageData });
//		document.querySelector(".copyright-idetail").removeEventListener('touchstart', this);
	}
//	let startPos = null;
//	let endPos = null;
//	let moveTimeout = null;
//	function bindTouchStart(event) {
//		let touch = event.targetTouches[0];
//		startPos = {x:touch.pageX,y:touch.pageY}; //取第一个touch的坐标值
//		document.querySelector(".copyright-idetail").addEventListener('touchmove',bindTouchMove, false);
//		document.querySelector(".copyright-idetail").addEventListener('touchend',bindTouchEnd, false);
//	}
//	function bindTouchMove(event) {
//		event.preventDefault();
//		//当屏幕有多个touch或者页面被缩放过，就不执行move操作
//		if(event.targetTouches.length > 1 || event.scale && event.scale !== 1) {
//			return;
//		}
//		let touch = event.targetTouches[0];
//		if (!startPos) {
//			startPos = {x:touch.pageX,y:touch.pageY}; //取第一个touch的坐标值
//		}
//		endPos = {x:touch.pageX,y:touch.pageY};
//		if (!moveTimeout) {
//			moveTimeout = setTimeout(doMove, 100);
//		}
//	}
//	function doMove() {
//		clearTimeout(moveTimeout);
//		let posY = endPos.y - startPos.y;
//		let dom = document.querySelector(".copyright-idetail");
////		if (Math.abs(posY) < 10) {
////			return;
////		}
//		if(endPos.y < startPos.y){
//			//手指向上,posY<0,scrollTop增加
//			let targetScroll = Math.abs(posY) + dom.scrollTop;
//			if (targetScroll > dom.offsetHeight) {
//				dom.scrollTop = dom.offsetHeight;
//			} else {
//				dom.scrollTop += Math.abs(posY);
//			}
//		} else {
//			//手指向下,posY>0,scrollTop减少
//			let targetScroll = dom.scrollTop - posY;
//			if (targetScroll < 0) {
//				dom.scrollTop = 0;
//			} else {
//				dom.scrollTop -= posY;
//			}
//		}
//		moveTimeout = setTimeout(doMove, 100);
//	}
//	function bindTouchEnd(event) {
//		startPos = null;
//		endPos = null;
//		clearTimeout(moveTimeout);
//		moveTimeout = null;
//		document.querySelector(".copyright-idetail").removeEventListener('touchmove', this);
//		document.querySelector(".copyright-idetail").removeEventListener('touchend', this);
//	}

	useEffect(() => {
		_track({
			trackName: 'toutu_idetail_page',
			payload: {
				id: defaultProps.items[photoIndex].id,
				topicId: defaultProps.items[photoIndex].topicId,
				url: defaultProps.items[photoIndex].originalUrl,
				page_action_name: 'idetail-pic'
			}
		});
		dispatch(
			getWeixinConfig({ url: window.location.href }, data => {
				console.log('getWeixinConfig', data);
				let pagePath = {};
				if (topicName) {
					pagePath = {
						toPage: 'activity',
						subPath: '/' + topicId
					};
				} else {
					pagePath = {
						toPage: 'home'
					};
				}
				configWeixin(data, {
					title: '投图',
					desc: '主题影像即时创作平台',
					...pagePath
				});
			})
		);
	}, [dispatch, topicId, topicName, defaultProps, photoIndex]);
	if (!defaultProps || defaultProps.length === 0) {
		onCloseIdetail();
		return;
	}
	let items = defaultProps.items;
	console.log('items', items, index);
	function onCloseIdetail() {
		if (pathname) {
			history.push({
				pathname,
				state: {
					cache: true,
					top
				}
			});
		} else {
			history.goBack();
		}
	}
	// function handleClickShareBtn() {
	// 	pageData.isShowShareTip = true;
	// 	setPageData({ ...pageData });
	// }
	// function handleClickShareTip() {
	// 	pageData.isShowShareTip = false;
	// 	setPageData({ ...pageData });
	// }
	function formatSource(list) {
		function formatItem(item) {
			let d = new Date(item.operateTime);
			let hour = String(d.getHours());
			let minute = String(d.getMinutes());
			let second = String(d.getSeconds());
			if (hour.length === 1) {
				hour = '0' + hour;
			}
			if (minute.length === 1) {
				minute = '0' + minute;
			}
			if (second.length === 1) {
				second = '0' + second;
			}
			return {
				time: hour + ':' + minute + ':' + second,
				operate: item.operate,
				comment: item.comment
			};
		}
		let stamps = [];
		let dataList = [];
		list.forEach(item => {
			let d = new Date(item.operateTime);
			let date = d.getDate();
			let month = d.getMonth() + 1;
			let year = d.getFullYear();
			let stamp = year + '.' + month + '.' + date;
			item = formatItem(item);
			if (!stamps.includes(stamp)) {
				stamps.push(stamp);
				dataList.push([item]);
			} else {
				dataList[dataList.length - 1].push(item);
			}
		});
		console.log([stamps, dataList]);
		return [stamps, dataList];
	}
	function source(resps) {
		let [stamps, dataList] = formatSource(resps);

		let iconMap = {
			SHOOT: '&#xe65d;',
			ORG_STMT: '&#xe660;',
			PUBLISH: '&#xe65c;'
		};
		function items(sourceList) {
			return sourceList.map(item => {
				return `<li>
						<span class="time">${item.time}</span>
						<span class="operate iconfont">${iconMap[item.operate] || ''}</span>
						<span class="comment">${item.comment}</span>
					</li>`;
			});
		}
		let list = stamps.map((stamp, index) => {
			return `<ul>
					<h3 class="date">${stamp}</h3>
					${items(dataList[index]).join('')}
				</ul>`;
		});

		return `<ul class="workTraceResps">${list.join('')}</ul>`;
	}
	function imageInfo(info) {
		//let { imgLayout = 'JPEG', imgSize = '4.3MB', imgPx = '6140 × 4912 像素', dateString = '2020年02月04日 12:00', author = 'Frank Wang' } = info || {};
		let equipment = ''; // 传输设备
		let location = imgInfo.city;
		let originalDocId = imgInfo.contentId;
		let isOriginal = imgInfo.isOriginal === 20; // 10：否  20：是
		let imgLayout = imgInfo.type === 1 ? 'JPEG' : '视频';
		let imgSize = parseFloat(imgInfo.size / 1024).toFixed(2) + 'KB';
		let imgPx = imgInfo.width + ' x ' + imgInfo.height + ' 像素';
		let dateString = moment(imgInfo.submitTime).format('YYYY-MM-DD HH:mm');
		let author = imgInfo.authorUserName || '未知';
		let resps = imgInfo.workTraceResps;
		return (
			'<div class="img-info-dialog">' +
			'<ul>' +
			(equipment ? `<li><label>传输设备</label><span>${equipment}</span></li>` : '') +
			'    <li>' +
			'        <label>照片格式</label>' +
			'        <span>' +
			imgLayout +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>照片大小</label>' +
			'        <span>' +
			imgSize +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>拍摄地点</label>' +
			'        <span>' +
			location +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>照片尺寸</label>' +
			'        <span>' +
			imgPx +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>原始文档ID</label>' +
			'        <span>' +
			originalDocId +
			'</span>' +
			'    </li>' +
			'</ul>' +
			'<ul>' +
			'    <li>' +
			'        <label>照片溯源</label>' +
			(isOriginal ? '<div class="original"><span class="iconfont original-icon">&#xe660;</span><span>原创</span><div>' : '') +
			'    </li>' +
			// '    <li>' +
			// '        <label>照片提交于</label>' +
			// '        <span>' +
			// dateString +
			// '</span>' +
			// '    </li>' +
			// '    <li>' +
			// '        <label>照片提交者</label>' +
			// '        <span>' +
			// author +
			// '</span>' +
			// '    </li>' +
			'</ul>' +
			source(resps) +
			// '<ul>' +
			// '    <li>' +
			// '        <label>版权说明</label>' +
			// '        <span>可免费使用，但不可用于商业+用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权</span>' +
			// '    </li>' +
			// '</ul>' +
			'</div>'
		);
	}
	function ImageInfoDialog(props) {
		return (
			<div className="dialog-wrapper">
				<div className="content">
					<header>
						<span>照片信息</span>
						<div className="right" onClick={toCopyrightNotice}>
							<span className="license-wrapper">
								<i className="iconfont cc-icon">&#xe65a;</i>
								<i className="iconfont by-icon">&#xe659;</i>
							</span>
							<span className="arrow-wrapper">
								<i className="iconfont arrow">&#xe655;</i>
							</span>
						</div>
					</header>
					{typeof props.text === 'string' ? <div className="text" dangerouslySetInnerHTML={{ __html: props.text }}></div> : <div className="text">{props.text}</div>}
					<footer onClick={props.clickFooter}>{props.footer}</footer>
				</div>
			</div>
		);
	}
	function DownloadDialog(props) {
		return (
			<div className="download dialog-wrapper">
				<div className="content">
					<header>
						<span>下载照片</span>
						<div className="right" onClick={toCopyrightNotice}>
							<span className="license-wrapper">
								<i className="iconfont cc-icon">&#xe65a;</i>
								<i className="iconfont by-icon">&#xe659;</i>
							</span>
							<span className="arrow-wrapper">
								<i className="iconfont arrow">&#xe655;</i>
							</span>
						</div>
					</header>
					{typeof props.text === 'string' ? <div className="text" dangerouslySetInnerHTML={{ __html: props.text }}></div> : <div className="text">{props.text}</div>}
					<footer onClick={props.clickFooter}>{props.footer}</footer>
				</div>
			</div>
		);
	}
	function toTopic() {
		if (pathname) {
			history.push({
				pathname
			});
		} else {
			window.location.href = '/vpmobile/copyright/home/';
		}
	}
	function toCopyrightNotice() {
		history.push({
			pathname: '/vpmobile/copyright/notice'
		});
	}
	function hasPhone() {
		let phone = readCookie('copyrightphone');
		if (phone && phone !== 'null') {
			return true;
		}
		return false;
	}
	function uploadDownloadInfo() {
		let _index = carouselIndex === -1 ? index : carouselIndex;
		let contentIds = [items[_index].contentId];
		let userId = readCookie('copyrightuserId');
		dispatch(
			sendDownloadInfo(
				{
					contentIds,
					userId
				},
				data => {},
				data => {
					console.log('error data', data);
				}
			)
		);
	}
	function showQRCode(url) {
		if (!hasPhone()) {
			window.location.href = '/vpmobile/copyright/login/' + window.location.search;
		}

		if (pageData.isShowDownload) {
			return;
		}
		pageData.isShowDownload = true;
		setPageData({ ...pageData });

		let _index = carouselIndex === -1 ? index : carouselIndex;
		let fd = new FormData();
		fd.append('appId', MINIPROGRAM_APPID);
		// fd.append('downloadUrl', items[_index].originalUrl);
		fd.append('downloadUrl', url);
		dispatch(
			getDownloadQRCode(
				fd,
				data => {
					pageData.isShowQRcodeInstruction = true;
					pageData.QRContent =
						'<div class="qrcode-wrap">' +
						'<img width="186" height="186" src="' +
						data.miniAppQrUrl +
						'" alt="小程序二维码" />' +
						'<div class="tip2">长按识别小程序码下载本图</div>' +
						'</div>';
					setPageData(clone(pageData));
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
					// return '<div class="qrcode-wrap">' + '<img width="162" height="162" src="' + data.miniAppQrUrl + '" alt="小程序二维码" />' + '<div class="tip2">长按识别小程序码下载本图</div>' + '</div>';
					uploadDownloadInfo();
				},
				data => {
					console.log('error data', data);
					Toast.fail('生成小程序码失败');
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
				}
			)
		);
	}
	function dialogFooter() {
		pageData.isShowInstruction = false;
		setPageData(clone(pageData));
	}
	function dialogQrCodeFooter() {
		pageData.isShowQRcodeInstruction = false;
		pageData.isShowDownload = false;
		setPageData(clone(pageData));
	}
	let currentIndex = !~carouselIndex ? index + 1 : carouselIndex + 1;
	console.log('carouselIndex...', currentIndex, carouselIndex);
	function getCurrentImgInfo(index) {
		let item = items[index - 1];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				_track({
					trackName: 'toutu_idetail_page',
					payload: {
						...data,
						page_action_name: 'idetail-imginfo'
					}
				});
				setImgInfo(data);
				console.log('img info', data);
			})
		);
	}
	// const setStateP = function ( hookFn , state) {
	// 	return new Promise(resolve => hookFn(state, resolve))
	// }
	function onOpenTip() {
		setIsDownloadTip(true);
	}
	function onOpenTipNext(url) {
		// setIsTooBig(true);
		setIsDownloadTip(false);
		showQRCode(url);
	}
	function onCloseTip() {
		if (isTooBig) {
			setIsTooBig(false);
		}
		setIsDownloadTip(false);
	}
	function  hasClassFun(element, cls){
	  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}
	let clickTimeId = null;
	function onVisibleToolbar() {
		let dom = document.querySelector(".PhotoView-SlideWrap");
		if (dom) {
			dom.ondblclick = onDocumenDblClick;
			dom.onclick = onDomClick;
		}
	}
	function onDomClick() {
		clearTimeout(clickTimeId);
		clickTimeId = setTimeout(function() {
			let dom = document.querySelector(".PhotoView-SlideWrap");
			if (dom) {
				if (hasClassFun(dom, "PhotoView-PhotoSlider__clean")) {
					document.querySelector(".idetail-top").style.opacity = 1;
					document.querySelector(".ideital-oprate").style.opacity = 1;
					document.querySelector(".page-desc").style.opacity = 1;
				} else {
					document.querySelector(".idetail-top").style.opacity = 0;
					document.querySelector(".ideital-oprate").style.opacity = 0;
					document.querySelector(".page-desc").style.opacity = 0;
				}
			}
		}, 300);
	}
	function onDocumenDblClick() {
		clearTimeout(clickTimeId);
		document.querySelector(".idetail-top").style.opacity = 0;
		document.querySelector(".ideital-oprate").style.opacity = 0;
		document.querySelector(".page-desc").style.opacity = 0;
	}
	onVisibleToolbar();
	setTimeout(onVisibleToolbar, 1000);
	console.log( "items.length......" , items);
	return (
		<div className="copyright copyright-idetail swiper-container">
			{/*<Carousel
				autoplay={false}
				infinite
				dots={false}
				selectedIndex={index}
				swipeSpeed={12}
				beforeChange={(from, to) => {
					setCarouselIndex(to);
					// console.log(`slide from ${from} to ${to}`);
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							from,
							to,
							index,
							pathname,
							topicName,
							topicId,
							page_action_name: 'idetail-silder-carousel'
						}
					});
				}}
				afterChange={index => {
					console.log('silde ...', index);
				}}>
				{items &&
					items.map((item, index) => {
						return (
							<div className="idetail-wrap" key={'idetail-img-' + index}>
								<div className="title">{(item.section || '').substring(0, 10)}</div>
								<img alt="" width="100%" src={item.originalUrl} onDoubleClick={onOpenView} onTouchStart={onTouchStart}/>
							</div>
						);
					})}
			</Carousel>*/}
			<PhotoSlider
        images={items.map(item => ({ src: item.originalUrl }))}
        visible={true}
        onClose={() => {history.go(-1)}}
        index={photoIndex}
        onIndexChange={setPhotoIndex}
      />
			{topicName ? (
				<div className="idetail-topic" onClick={toTopic}>
					<span className="iconfont topic"></span>
					<span>{topicName}</span>
					<i className="iconfont icon">&#xe655;</i>
				</div>
			) : (
				''
			)}
			<div className="idetail-top">
			<div
				className="idetail-info"
				onClick={() => {
					getCurrentImgInfo(currentIndex);
					pageData.isShowInstruction = true;
					setPageData(clone(pageData));
				}}>
				&#xe654;
			</div>
			<div className="idetail-close" onClick={onCloseIdetail}>
				&#xe652;
			</div>
			</div>
			<ul className="ideital-oprate">
				<li onClick={showShare}>
					<i>&#xe657;</i>
					<br />
					分享
				</li>
				<li onClick={onOpenTip}>
					<i>&#xe656;</i>
					<br />
					下载
				</li>
			</ul>
			<div className="page-desc">
				<div className="number">
					{photoIndex+1}/{items.length}
				</div>
				<div className="text">
					<p className="title">{items[photoIndex].sectionDescription}</p>
					<p className="des">{items && photoIndex && items.length >= photoIndex ? items[photoIndex].description : ''}</p>
					{/* 可免费使用，但不可用于商业用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权可免费使用，但不可用于商业用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权 */}
				</div>
			</div>
			{pageData.isOpen ? <WxImageViewer onClose={onCloseView} urls={items.map(item => item.originalUrl)} index={carouselIndex} /> : ''}
			{pageData.isShowInstruction ? <ImageInfo text={imageInfo()} clickFooter={dialogFooter} clickIcon={toCopyrightNotice} footer={'关闭'} /> : ''}
			{pageData.isShowQRcodeInstruction ? <TextDialog title="照片下载" text={pageData.QRContent} clickFooter={dialogQrCodeFooter} footer={'关闭'} /> : ''}
			{pageData.isShowShare ? <DetailShare data={pageData.sharedData} onClose={closeShare} /> : ''}
			{isDownloadTip ? <DownloadTip isDownloadTip={isDownloadTip} imgInfo={defaultProps.items} index={index} onClose={onCloseTip} onOpenTipNext={onOpenTipNext}></DownloadTip> : ''}
		</div>
	);
}
export { CopyrightIdetail };
